"use strict";


/*****************
 ** WEBPACK FOOTER
 ** ./components/locale-provider/style/index.tsx
 ** module id = 355
 ** module chunks = 0
 **/